import { render, staticRenderFns } from "./RegistrationFormWorkerJoin.vue?vue&type=template&id=5effb13a&"
import script from "./RegistrationFormWorkerJoin.vue?vue&type=script&lang=js&"
export * from "./RegistrationFormWorkerJoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports